import { useState, useEffect, useRef  } from 'react';
import { Info } from 'lucide-react';
import { useSelector } from 'react-redux';
import useApi from '../../../CustomHooks/useApi';
import { useNavigate } from "react-router-dom";

import { Clock } from 'lucide-react';

import { useDispatch } from "react-redux";
import {
    fetchWalletBalance,
    fetchAepsBalance,
    fetchSettlementBalance,
} from "../../../Store/Slices/WalletSlice";

const BillPlans = ({ onBack, operator, rnum, billerCategory }) => {


    console.log("fjhsjbdjsbvbdvdjvhjdvd", rnum)

    const [pinValues, setPinValues] = useState(['', '', '', '', '', '']);
    const [activeIndex, setActiveIndex] = useState(0);
    const inputRefs = useRef([]);
    const [billDetails, setBillDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isFetchingBill, setIsFetchingBill] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [transactionResponse, setTransactionResponse] = useState(null);
    const merchantId = useSelector((state) => state.auth.employeeDetails?.username);
    const account_no = useSelector((state) => state.auth.employeeDetails?.merchant_account_no);
    const [mpinError, setMpinError] = useState("");
    const [shakeMpin, setShakeMpin] = useState(false);
    const [billError, setBillError] = useState("");
    const [showMpin, setShowMpin] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { callApi: callBillInfo } = useApi("/recharge/bill-info", "POST");
    const { callApi: callWaterInfo } = useApi("/recharge/water-info", "POST");
    const { callApi: callGasInfo } = useApi("/recharge/gas-info", "POST");
    const { callApi: callInsuranceFetch } = useApi("/recharge/insurance-fetch", "POST");
    const { callApi: billpay } = useApi("/recharge/transaction/indicore", "POST");


    const generateCack = () => {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    };



    useEffect(() => {
        fetchBillPlans(billerCategory);
    }, [operator]);

    const fetchBillPlans = async (billerCategory) => {
        setIsFetchingBill(true);
        setErrorMessage(null);
        setBillDetails(null);

        const cackValue = generateCack();

        if (billerCategory === "ebill") {
            try {
                const billpayload = {
                    signature: "994AABEB7344ACB79AB67FFB0D74C10642968510A82285F499E946F3A1513175",
                    cack: cackValue,
                    number: rnum.rnum,
                    operator: operator,
                    merchantId: merchantId,
                    addParams: {
                        optional: rnum.optional
                    }
                }
                const response = await callBillInfo(billpayload);

                if (response.status === 1 && Array.isArray(response.rdata) && response.rdata[0]?.status === 1) {
                    const billInfo = response.rdata[0];

                    setBillDetails({
                        customerName: billInfo.CustomerName,
                        billAmount: billInfo.Billamount,
                        billDate: billInfo.Billdate,
                        dueDate: billInfo.Duedate,
                        billValidationId: response?.billValidationId || "",
                        consumerNo: response?.mobile || "",
                    });
                } else {
                    setErrorMessage(response.message || "No valid bill data found.");
                }
            } catch (err) {
                console.error("API Fetch Error:", err);
                setErrorMessage(err.message || "Failed to load bill details. Please try again.");
            }
        } else if (billerCategory === "water") {
            try {
                const billpayload = {
                    signature: "994AABEB7344ACB79AB67FFB0D74C10642968510A82285F499E946F3A1513175",
                    cack: cackValue,
                    number: rnum.rnum,
                    operator: operator,
                    merchantId: merchantId,
                    addParams: {
                        optional: rnum.optional
                    }
                }
                const response = await callWaterInfo(billpayload);

                if (response.status === 1 && Array.isArray(response.rdata) && response.rdata[0]?.status === 1) {
                    const billInfo = response.rdata[0];

                    setBillDetails({
                        customerName: billInfo.CustomerName,
                        billAmount: billInfo.Billamount,
                        billDate: billInfo.Billdate,
                        dueDate: billInfo.Duedate,
                        addParams: {
                            optional: rnum.optional
                        }
                    });
                } else {
                    setErrorMessage(response.message || "No valid bill data found.");
                }
            } catch (err) {
                console.error("API Fetch Error:", err);
                setErrorMessage(err.message || "Failed to load water bill details. Please try again.");
            }
        } else if (billerCategory === "gas") {
            try {
                const billpayload = {
                    signature: "994AABEB7344ACB79AB67FFB0D74C10642968510A82285F499E946F3A1513175",
                    cack: cackValue,
                    number: rnum.rnum,
                    operator: operator,
                    merchantId: merchantId,
                    addParams: {
                        optional: rnum.optional
                    }
                }
                const response = await callGasInfo(billpayload);

                if (response.status === 1 && Array.isArray(response.rdata) && response.rdata[0]?.status === 1) {
                    const billInfo = response.rdata[0];

                    setBillDetails({
                        customerName: billInfo.CustomerName,
                        billAmount: billInfo.Billamount,
                        billDate: billInfo.Billdate,
                        dueDate: billInfo.Duedate
                    });
                } else {
                    setErrorMessage(response.message || "No valid bill data found.");
                }
            } catch (err) {
                console.error("API Fetch Error:", err);
                setErrorMessage(err.message || "Failed to load gas bill details. Please try again.");
            }
        } else if (billerCategory === "ins") {
            try {
                const billpayload = {
                    signature: "994AABEB7344ACB79AB67FFB0D74C10642968510A82285F499E946F3A1513175",
                    cack: cackValue,
                    number: rnum.rnum,
                    operator: operator,
                    merchantId: merchantId,
                    // addParams: {
                    //     optional: rnum.optional,
                    //     optional1: rnum.optional1
                    // },
                }
                const response = await callInsuranceFetch(billpayload);

                if (response.status === 1 && Array.isArray(response.rdata) && response.rdata[0]?.status === 1) {
                    const billInfo = response.rdata[0];

                    // setBillDetails({
                    //     customerName: billInfo.CustomerName,
                    //     billAmount: billInfo.Billamount,
                    //     billDate: billInfo.Billdate,
                    //     dueDate: billInfo.Duedate
                    // });
                    setBillDetails({
                        customerName: billInfo.CustomerName || "N/A",
                        billAmount: billInfo.Netamount || "N/A",

                        // Bill Date → use explicit Duedate if present
                        billDate: billInfo.Duedate || "N/A",

                        // Bill Due Date → ALWAYS show Duedatefromto as received
                        dueDate: billInfo.Duedatefromto || "N/A"
                    });
                } else {
                    setErrorMessage(response.message || "No valid bill data found.");
                }
            } catch (err) {
                console.error("API Fetch Error:", err);
                setErrorMessage(err.message || "Failed to load insurance details. Please try again.");
            }
        }

        setIsFetchingBill(false);
    }

    const paynowbill = async () => {
        if (!billDetails || billDetails.billAmount === "0.0") {
            setBillError("Bill amount is zero. Payment not allowed.");
            return;
        }
        // if (!billDetails) {
        //     setBillError("Bill details not available.");
        //     return;
        // }

        const mpin = pinValues.join("");

        if (mpin.length !== 6) {
            setMpinError("Please enter 6-digit MPIN");
            setShakeMpin(true);

            setTimeout(() => setShakeMpin(false), 400);
            return;
        }

        let optionalData = {};

        if (billDetails) {
            optionalData = {
                billValidationId: billDetails?.billValidationId || "",
                consumerNo: billDetails?.consumerNo || "",
                consumerName: billDetails?.customerName || "",
                billDate: billDetails?.billDate || "",
                dueDate: billDetails?.dueDate || "",
                billAmount: billDetails?.billAmount || "",
                optional: rnum.optional || "",
                optional1: rnum.optional1 || "",
            };
        }

        setIsLoading(true);
        let type = "";
        if (billerCategory === "ebill") type = "EBILL";
        else if (billerCategory === "water") type = "WATER";
        else if (billerCategory === "gas") type = "GAS";
        else if (billerCategory === "ins") type = "INS";

        const payload = {
            signature: "994AABEB7344ACB79AB67FFB0D74C10642968510A82285F499E946F3A1513175",
            rnum: rnum.rnum,
            optr: operator,
            type: type,
            mid: merchantId,
            txn_amount: billDetails.billAmount,
            net_amount: billDetails.billAmount,
            merchant_account_no: account_no,
            mpin: mpin,
            add_params: {
                ...optionalData
            }
        };

        try {
            const response = await billpay(payload);
            console.log("Transaction response:", response);
            // setTransactionResponse({
            //     status: String(response.status).toUpperCase(),
            //     message: response.customerSummary,
            //     txnId: response.txnId || "N/A"
            // });
            // let uiStatus = "FAILED";

            // if (response?.status === 200) {
            //     uiStatus = "SUCCESS";
            // } else if (response?.status === 202) {
            //     uiStatus = "FAILED"; // Invalid MPIN / business error
            // }

            // const normalizedMessage =
            //     response?.message?.toLowerCase().includes("mpin")
            //         ? "Invalid MPIN"
            //         : response?.message || "Transaction failed";

            // const rawMessage =
            //     response?.message ||
            //     response?.customerSummary ||
            //     "";

            // const statusSource =
            //     `${response?.status || ""} ${rawMessage}`.toUpperCase();

            // let uiStatus = "FAILED";

            // if (statusSource.includes("SUCCESS")) {
            //     uiStatus = "SUCCESS";
            // } else if (statusSource.includes("PENDING")) {
            //     uiStatus = "PENDING";
            // }

            // const rawMessage =
            //     response?.message ||
            //     response?.customerSummary ||
            //     "";

            // const statusSource =
            //     `${response?.status || ""} ${rawMessage}`.toUpperCase();

            // /**
            //  * UI RULE:
            //  * - ONLY explicit SUCCESS → SUCCESS
            //  * - EVERYTHING ELSE → PENDING
            //  */
            // let uiStatus = "PENDING";

            // if (statusSource.includes("MPIN")) {
            //     uiStatus = "MPIN_ERROR";
            // } else if (statusSource.includes("SUCCESS")) {
            //     uiStatus = "SUCCESS";
            // }
            const rawMessage =
                response?.message ||
                response?.customerSummary ||
                "";

            /**
             * 🔴 HARD OVERRIDE RULE
             * If error_code is present → treat as FAILED
             * and show ONLY message in popup
             */
            if (response?.error_code) {
                setTransactionResponse({
                    status: "API_ERROR",
                    message: rawMessage,
                    txnId: "N/A"
                });
                return;
            }

            /**
             * NORMAL FLOW (no error_code)
             */
            const statusSource =
                `${response?.status || ""} ${rawMessage}`.toUpperCase();

            let uiStatus = "PENDING";

            if (statusSource.includes("MPIN")) {
                uiStatus = "MPIN_ERROR";
            } else if (statusSource.includes("SUCCESS")) {
                uiStatus = "SUCCESS";
            }

            setTransactionResponse({
                status: uiStatus,
                message: rawMessage,
                txnId: response?.txnId || "N/A"
            });



            setTransactionResponse({
                status: uiStatus,
                message: rawMessage,
                txnId: response?.txnId || "N/A"
            });
        } catch (error) {
            console.error("Transaction error:", error);
            setTransactionResponse({
                status: "FAILED",
                message: error?.message || "",
                txnId: "N/A"
            });
        } finally {
            setIsLoading(false);
            setShowPopup(true);
            setPinValues(['', '', '', '', '', '']);
            setActiveIndex(0);
            setMpinError("");
            setBillError("");
            setShowMpin(false);
            dispatch(fetchWalletBalance());
            dispatch(fetchAepsBalance());
            dispatch(fetchSettlementBalance());
        }
    }

    const handlePopupClose = () => {
        setShowPopup(false);

        // If MPIN error → allow retry
        if (transactionResponse?.status === "MPIN_ERROR") {
            setShowMpin(true);
            setPinValues(['', '', '', '', '', '']);
            setActiveIndex(0);
            return;
        }

        // Only navigate back on success
        // if (transactionResponse?.status === "SUCCESS") {
        //     onBack();
        // }
        navigate("/retailerdashboard");
    };

    const handleInputChange = (e, index) => {
        const val = e.target.value.replace(/[^0-9]/g, '');
        const newPin = [...pinValues];
        newPin[index] = val;
        setPinValues(newPin);

        if (mpinError) setMpinError("");

        if (val && index < pinValues.length - 1) {
            inputRefs.current[index + 1]?.focus();
            setActiveIndex(index + 1);
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (pinValues[index]) {
                const newPin = [...pinValues];
                newPin[index] = "";
                setPinValues(newPin);
            } else if (index > 0) {
                inputRefs.current[index - 1]?.focus();
                setActiveIndex(index - 1);
            }
        }
    };

    const handlePinClick = (index) => {
        inputRefs.current[index]?.focus();
        setActiveIndex(index);
    };


    // const TransactionPopup = () => {
    //     if (!showPopup) return null;

    //     const isSuccess =
    //         transactionResponse &&
    //         String(transactionResponse.status).toUpperCase() === "SUCCESS";

    //     return (
    //         <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
    //             <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 shadow-lg">
    //                 <div className="text-center mb-4">
    //                     {isSuccess ? (
    //                         <div className="text-green-500 mb-2">
    //                             <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    //                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
    //                             </svg>
    //                             <h3 className="text-xl font-semibold mt-2">Transaction Successful</h3>
    //                         </div>
    //                     ) : (
    //                         <div className="text-red-500 mb-2">
    //                             <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    //                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
    //                             </svg>
    //                             <h3 className="text-xl font-semibold mt-2">Transaction Failed</h3>
    //                         </div>
    //                     )}
    //                 </div>

    //                 <div className="bg-gray-50 rounded-lg p-4 text-left mb-4">
    //                     <p className="my-1"><span className="font-medium">Status:</span> {transactionResponse?.status}</p>
    //                     <p className="my-1"><span className="font-medium">Message:</span> {transactionResponse?.message}</p>
    //                     {transactionResponse?.txnId !== "N/A" && (
    //                         <p className="my-1"><span className="font-medium">Transaction ID:</span> {transactionResponse?.txnId}</p>
    //                     )}
    //                     <p className="my-1"><span className="font-medium">Amount:</span> ₹{billDetails?.billAmount}</p>
    //                     <p className="my-1"><span className="font-medium">Bill Category:</span> {billerCategory?.toUpperCase()}</p>
    //                 </div>

    //                 <button
    //                     className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-lg font-medium transition-colors"
    //                     onClick={handlePopupClose}
    //                 >
    //                     OK
    //                 </button>
    //             </div>
    //         </div>
    //     );
    // };


    // const TransactionPopup = () => {
    //     if (!showPopup) return null;

    //     const status = String(transactionResponse?.status || "").toUpperCase();

    //     const isApiError = status === "API_ERROR";
    //     // const isInvalidMpin =
    //     //     transactionResponse?.message === "Invalid MPIN";
    //     // const isInvalidMpin =
    //     //     transactionResponse?.message
    //     //         ?.toUpperCase()
    //     //         .includes("MPIN");
    //     const isInvalidMpin = status === "MPIN_ERROR";

    //     const isSuccess = status === "SUCCESS";
    //     const isPending = status === "PENDING";
    //     const isFailed = status === "FAILED";

    //     return (
    //         <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
    //             <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 shadow-lg">

    //                 {/* ===== STATUS HEADER ===== */}
    //                 <div className="text-center mb-4">

    //                     {isSuccess && (
    //                         <div className="text-green-500 mb-2">
    //                             <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    //                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
    //                             </svg>
    //                             <h3 className="text-xl font-semibold mt-2">
    //                                 Transaction Successful
    //                             </h3>
    //                         </div>
    //                     )}

    //                     {isPending && !isInvalidMpin && (
    //                         <div className="text-yellow-500 mb-2">
    //                             <svg
    //                                 className="w-16 h-16 mx-auto animate-spin"
    //                                 fill="none"
    //                                 stroke="currentColor"
    //                                 viewBox="0 0 24 24"
    //                             >
    //                                 <circle cx="12" cy="12" r="10" strokeWidth="4" className="opacity-25" />
    //                                 <path d="M12 2a10 10 0 0110 10" strokeWidth="4" className="opacity-75" />
    //                             </svg>

    //                             <h3 className="text-xl font-semibold mt-2">
    //                                 Transaction Initiated
    //                             </h3>
    //                             <p className="text-sm mt-1">
    //                                 Your transaction has been initiated and is being processed
    //                             </p>
    //                         </div>
    //                     )}

    //                     {isFailed && !isInvalidMpin && (
    //                         <div className="text-red-500 mb-2">
    //                             <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    //                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
    //                             </svg>
    //                             <h3 className="text-xl font-semibold mt-2">
    //                                 Transaction Failed
    //                             </h3>
    //                         </div>
    //                     )}

    //                 </div>

    //                 {/* ===== DETAILS ===== */}
    //                 {/* <div className="bg-gray-50 rounded-lg p-4 text-left mb-4">
    //                     <p className="my-1">
    //                         <span className="font-medium">Status:</span> {transactionResponse?.status}
    //                     </p>
    //                     <p className="my-1">
    //                         <span className="font-medium">Message:</span> {transactionResponse?.message}
    //                     </p>

    //                     {transactionResponse?.txnId && transactionResponse?.txnId !== "N/A" && (
    //                         <p className="my-1">
    //                             <span className="font-medium">Transaction ID:</span> {transactionResponse?.txnId}
    //                         </p>
    //                     )}

    //                     <p className="my-1">
    //                         <span className="font-medium">Amount:</span> ₹{billDetails?.billAmount}
    //                     </p>
    //                     <p className="my-1">
    //                         <span className="font-medium">Bill Category:</span> {billerCategory?.toUpperCase()}
    //                     </p>
    //                 </div> */}
    //                 <div className="bg-gray-50 rounded-lg p-4 text-center mb-4">

    //                     {isInvalidMpin ? (
    //                         <p className="text-red-600 text-lg font-semibold">
    //                             Invalid MPIN
    //                         </p>
    //                     ) : (
    //                         <>
    //                             <p className="my-1">
    //                                 <span className="font-medium">Status:</span> {transactionResponse?.status}
    //                             </p>

    //                             <p className="my-1">
    //                                 <span className="font-medium">Message:</span> {transactionResponse?.message}
    //                             </p>

    //                             {transactionResponse?.txnId && transactionResponse?.txnId !== "N/A" && (
    //                                 <p className="my-1">
    //                                     <span className="font-medium">Transaction ID:</span> {transactionResponse?.txnId}
    //                                 </p>
    //                             )}

    //                             <p className="my-1">
    //                                 <span className="font-medium">Amount:</span> ₹{billDetails?.billAmount}
    //                             </p>

    //                             <p className="my-1">
    //                                 <span className="font-medium">Bill Category:</span> {billerCategory?.toUpperCase()}
    //                             </p>
    //                         </>
    //                     )}

    //                 </div>


    //                 {/* ===== ACTION ===== */}
    //                 <button
    //                     className="w-full py-3 rounded-lg font-medium transition-colors bg-blue-500 hover:bg-blue-600 text-white cursor-pointer"
    //                     onClick={handlePopupClose}
    //                 >
    //                     OK
    //                 </button>

    //             </div>
    //         </div>
    //     );
    // };

    const TransactionPopup = () => {
        if (!showPopup) return null;

        const status = String(transactionResponse?.status || "").toUpperCase();

        const isApiError = status === "API_ERROR";
        const isInvalidMpin = status === "MPIN_ERROR";

        const isSuccess = status === "SUCCESS";
        const isPending = status === "PENDING";
        const isFailed = status === "FAILED";

        return (
            <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">

                <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 shadow-lg">

                    {/* ===== STATUS HEADER (NOT SHOWN FOR API_ERROR) ===== */}
                    {!isApiError && (
                        <div className="text-center mb-4">

                            {isSuccess && (
                                <div className="text-green-500 mb-2">
                                    <svg
                                        className="w-16 h-16 mx-auto"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                    </svg>
                                    <h3 className="text-xl font-semibold mt-2">
                                        Transaction Successful
                                    </h3>
                                </div>
                            )}

                            {isPending && !isInvalidMpin && (
                                <div className="text-yellow-500 mb-2">
                                    {/* <svg
                                        className="w-16 h-16 mx-auto animate-spin"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle cx="12" cy="12" r="10" strokeWidth="4" className="opacity-25" />
                                        <path d="M12 2a10 10 0 0110 10" strokeWidth="4" className="opacity-75" />
                                    </svg> */}

                                    <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-yellow-100 flex items-center justify-center">
            <Clock className="w-9 h-9 text-yellow-600" strokeWidth={2.2} />
        </div>

                                    <h3 className="text-xl font-semibold mt-2">
                                        Transaction Initiated
                                    </h3>
                                    <p className="text-sm mt-1">
                                        Your transaction has been initiated and is being processed
                                    </p>
                                </div>
                            )}

                            {isFailed && !isInvalidMpin && (
                                <div className="text-red-500 mb-2">
                                    <svg
                                        className="w-16 h-16 mx-auto"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                    <h3 className="text-xl font-semibold mt-2">
                                        Transaction Failed
                                    </h3>
                                </div>
                            )}

                        </div>
                    )}

                    {/* ===== DETAILS ===== */}
                    <div className="bg-gray-50 rounded-lg p-4 text-center mb-4">

                        {/* 🔴 error_code PRESENT → SHOW ONLY MESSAGE */}
                        {isApiError ? (
                            <p className="text-red-600 text-lg font-semibold break-words">
                                {transactionResponse?.message}
                            </p>
                        ) : isInvalidMpin ? (
                            <p className="text-red-600 text-lg font-semibold">
                                Invalid MPIN
                            </p>
                        ) : (
                            <>
                                <p className="my-1">
                                    <span className="font-medium">Status:</span>{" "}
                                    {transactionResponse?.status}
                                </p>

                                <p className="my-1">
                                    <span className="font-medium">Message:</span>{" "}
                                    {transactionResponse?.message}
                                </p>

                                {transactionResponse?.txnId &&
                                    transactionResponse?.txnId !== "N/A" && (
                                        <p className="my-1">
                                            <span className="font-medium">Transaction ID:</span>{" "}
                                            {transactionResponse?.txnId}
                                        </p>
                                    )}

                                <p className="my-1">
                                    <span className="font-medium">Amount:</span>{" "}
                                    ₹{billDetails?.billAmount}
                                </p>

                                <p className="my-1">
                                    <span className="font-medium">Bill Category:</span>{" "}
                                    {billerCategory?.toUpperCase()}
                                </p>
                            </>
                        )}
                    </div>

                    {/* ===== ACTION ===== */}
                    <button
                        className="w-full py-3 rounded-lg font-medium transition-colors bg-blue-500 hover:bg-blue-600 text-white cursor-pointer"
                        onClick={handlePopupClose}
                    >
                        OK
                    </button>

                </div>
            </div>
        );
    };


    return (
        <div className="bg-gray-50 rounded-lg shadow-sm w-full mt-10">
            <div className="p-4 border-b border-gray-200">
                <p className="text-sm text-gray-500">Please make your payment by the due date to avoid any late fees.</p>
            </div>

            <div className="p-4 flex items-center space-x-3 border-b border-gray-200">
                <button className="text-blue-500 text-sm" onClick={onBack}>Go Back</button>
            </div>

            <div className="p-4">
                <h2 className="text-lg font-bold mb-4">Bill details</h2>

                {isFetchingBill ? (
                    <div className="flex flex-col items-center justify-center py-8">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
                        <p className="text-gray-600">Fetching bill details...</p>
                    </div>
                ) : errorMessage ? (
                    <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md mb-6">
                        <p className="font-medium">Error</p>
                        <p className="text-sm">{errorMessage}</p>
                        <button
                            className="mt-2 text-sm text-red-600 hover:text-red-800 underline"
                            onClick={() => fetchBillPlans(billerCategory)}
                        >
                            Try Again
                        </button>
                    </div>
                ) : billDetails ? (
                    <>
                        <div className="flex justify-between mb-3">
                            <span className="text-gray-700">Consumer Name:</span>
                            <span className="font-medium">{billDetails.customerName || "N/A"}</span>
                        </div>

                        {/* <div className="flex justify-between mb-3">
                            <span className="text-gray-700">Bill due date :</span>
                            <span className="font-medium">{billDetails.dueDate || "N/A"}</span>
                        </div> */}

                        <div className="flex justify-between mb-3">
                            <span className="text-gray-700">Bill date :</span>
                            <span className="font-medium">{billDetails.billDate || "N/A"}</span>
                        </div>

                        <div className="flex justify-between mb-6">
                            <span className="text-gray-700">Payable amount :</span>
                            <span className="font-medium">{billDetails.billAmount || "N/A"}</span>
                        </div>
                    </>
                ) : null}

                {billError && (
                    <p className="text-red-600 text-sm mb-4">
                        {billError}
                    </p>
                )}

                {showMpin && (
                    <div className="mb-6">
                        <h3 className="text-sm font-semibold mb-3">MPIN Verification</h3>

                        <div
                            className={`flex gap-3 justify-center ${shakeMpin ? "animate-shake" : ""
                                }`}
                        >
                            {pinValues.map((val, index) => (
                                <input
                                    key={index}
                                    ref={(el) => (inputRefs.current[index] = el)}
                                    type="password"
                                    maxLength={1}
                                    value={val}
                                    onChange={(e) => handleInputChange(e, index)}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    onClick={() => handlePinClick(index)}
                                    className={`
          w-10 h-10 text-center rounded-md border outline-none
          ${activeIndex === index ? "border-green-500" : "border-gray-300"}
          ${val ? "bg-white" : "bg-gray-100"}
        `}
                                />
                            ))}
                        </div>

                        {/* ✅ MPIN INLINE ERROR MESSAGE — ADD HERE */}
                        {mpinError && (
                            <p className="text-red-600 text-xs mt-2 text-center">
                                {mpinError}
                            </p>
                        )}
                    </div>
                )}


                {/* <button
                    className={`bg-green-500 hover:bg-green-600 text-white font-medium px-4 py-2 rounded-md text-sm w-40 transition-colors 
                    ${(isLoading || isFetchingBill || !billDetails) ? 'opacity-50 cursor-not-allowed bg-gray-400 hover:bg-gray-400' : ''}`}
                    onClick={paynowbill}
                    disabled={isLoading || isFetchingBill || !billDetails || pinValues.join("").length !== 6}
                >
                    {isLoading ? "Processing..." : isFetchingBill ? "Please wait..." : "Pay Now"}
                </button> */}
                {!showMpin && (
                    <button
                        className={`bg-green-500 hover:bg-green-600 text-white font-medium px-4 py-2 rounded-md text-sm w-40 transition-colors
      ${(isLoading || isFetchingBill || !billDetails)
                                ? "opacity-50 cursor-not-allowed bg-gray-400 hover:bg-gray-400"
                                : ""
                            }`}
                        onClick={() => setShowMpin(true)}
                        disabled={isLoading || isFetchingBill || !billDetails}
                    >
                        Pay Now
                    </button>
                )}

                {showMpin && (
                    <button
                        className={`bg-indigo-600 hover:bg-indigo-700 text-white font-medium px-4 py-2 rounded-md text-sm w-40 transition-colors
        ${(isLoading || pinValues.join("").length !== 6)
                                ? "opacity-50 cursor-not-allowed bg-gray-400 hover:bg-gray-400"
                                : ""
                            }`}
                        onClick={paynowbill}
                        disabled={isLoading || pinValues.join("").length !== 6}
                    >
                        {isLoading ? "Processing..." : "Continue"}
                    </button>
                )}

                <div className="flex items-center text-gray-500 text-sm mt-4">
                    <Info size={16} className="mr-2" />
                    <span>The payment will reflect at biller's end after 2-3 working days.</span>
                </div>
            </div>

            <div className="h-3 bg-blue-500 rounded-b-lg"></div>

            <TransactionPopup />
        </div>
    );
}

export default BillPlans;